import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import './modules/common';
import './modules/news-slider';
import './modules/catalog-text';
import './modules/viewed';

/**
 * Слайдер на главной
 */
let mainSwiper = new Swiper('#mainSwiper', {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

/**
 * Слайдер партнеры
 */
let partnersSwiper = new Swiper('#partnersSwiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    grabCursor: true,
    breakpoints: {
      1200: {
        spaceBetween: 40,
      },
    },
});
